import { render, staticRenderFns } from "./CollapsibleContent.vue?vue&type=template&id=25cbfec1&"
import script from "./CollapsibleContent.vue?vue&type=script&lang=js&"
export * from "./CollapsibleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports